const getters = {
  token: state => state.user.token,
  username: state => state.user.username,
  userauth: state => state.user.userauth,
  loading: state => state.loading.loading,
};
export default getters;
